
import { ApiRetailer } from "@api/interfaces";
import { Avatar } from "@/components/DesignSystem/Avatar/Avatar";
import { AppConfig } from "@/constants/AppConfig";
import { AvatarProps } from "@mui/material";

interface RetailerAvatarProps extends AvatarProps {
  retailer?: ApiRetailer | null,
  size?: number,
}

export const RetailerAvatar = ({
  retailer,
  size = 56,
  ...rest
}: RetailerAvatarProps) => {
  return (
    <Avatar
      defaultIcon="retailer"
      outlined={true}
      shape="square"
      size={size}
      src={retailer?.logomark ? `${AppConfig.staticImageHost}/${retailer.logomark}` : undefined}
      {...rest}
    />
  );
};